/**
 * Sends one file into a workspace (POST .../uploads) and refreshes the workspace's upload list. The server reads the
 * file and answers with the upload waiting for its column check.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/components/common/Toast';
import { uploadService } from '@/services/upload.service';
import { uploadsKey } from '@/config/upload';
import { uploadErrorMessage } from '@/utils/upload';

export function useUploadFile(workspace: string) {
  const { addToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => uploadService.upload(workspace, file),
    // the dialog moves on to the column check: no toast
    onSuccess: () => queryClient.invalidateQueries({ queryKey: uploadsKey(workspace) }),
    onError: (error) => addToast(uploadErrorMessage(error), 'error'),
  });
}
